<template>
    <div class="container">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <div>
                <h1 class="mb-0">Liste des utilisateurs</h1>
                <small class="text-muted">Total : {{ users.length }} utilisateurs</small>
            </div>
            <button class="btn btn-primary" @click="$router.push({ name: 'users.create' })">
                <i class="bi bi-person-plus me-1"></i>Ajouter
            </button>
        </div>

        <div class="row" v-if="users.length">
            <div class="card">
                <div class="card-body">
                    <table class="table table-responsive table-striped">
                        <thead>
                            <tr>
                                <th>Nom</th>
                                <th>Prénom</th>
                                <th>Téléphone</th>
                                <th>
                                    <span class="d-none d-md-block text-end">Actions</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="user in users" :key="user.id" >
                                <tr v-if="user.id != userStore.$state.user?.id">
                                    <td>{{ user.name }}</td>
                                    <td>{{ user.prenoms }}</td>
                                    <td>{{ formatPhone(user.telephone) }}</td>
                                    <td>
                                        <div class="d-flex align-items-center justify-content-end">
                                            <i class="bi bi-caret-right-fill d-block d-lg-none"
                                                @click="$router.push({ name: 'users.view', params: { id: user.id } })"></i>
                                            <div class="d-none d-lg-block">
                                                <button class="btn btn-primary "
                                                    @click="$router.push({ name: 'users.view', params: { id: user.id } })">Détails</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-else>
            <p>Aucun utilisateur trouvé</p>
        </div>
    </div>
</template>

<script>

import { formatPhone } from '@/helpers/textFormater';
import { useUserStore } from '@/store/userStore';

export default {
    name: "UserList",
    data: () => ({
        users: [],
        url: "/users"
    }),

    methods: {
        formatPhone,
        getUsers() {
            this.$api.get(this.url)
                .then(response => {
                    this.users = response.data.data;
                }
                )
                .catch((error) => {
                    console.log(error)
                })
        }
    },

    computed: {
        userStore: ()=>useUserStore(),
    },

    created() {
        this.getUsers();
    }
}

</script>